import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { Subscription } from "rxjs";
import { AlertService } from "../services/index";
import { ACCOUNTS_URL, REST_API_REQUEST_CALL_URL } from "../utils/index";
import { HttpParams } from "@angular/common/http";

@Injectable()
export class ApiService {
  token = sessionStorage.getItem("_vcd");
  headers = new HttpHeaders()
    .set("tx-clientid", "tradlinx")
    .set("Access-Control-Allow-Origin", "*")
    .set("Authorization", "Bearer " + this.token);

  constructor(
    private alertService: AlertService,
    private httpClient: HttpClient
  ) {}

  private getHeaders(): HttpHeaders {
    let token = sessionStorage.getItem("_vcd");

    return new HttpHeaders()
      .set("Access-Control-Allow-Origin", "*")
      .set("Authorization", "Bearer " + token)
      .set("tx-clientid", "tradlinx");
  }

  getTimeZone(lat, lng) {
    let timestamp: string = String(new Date().getTime() - 32400);
    return this.httpClient.get(
      "https://maps.googleapis.com/maps/api/timezone/json?location=" +
        lat +
        "," +
        lng +
        "&timestamp=1331161200&language=kr&key=AIzaSyCxQ2MJivaJsyodlYsFa00u4S-_sSQbceA"
    );
  }

  get(url: string, params?): Observable<any> {
    url = this.makeFullUrlByType(url, "base");
    let headers = this.getHeaders();

    if (params) {
      let httpParams: HttpParams = this.makeHttpParam(params);
      return this.httpClient.get(url, {
        headers: headers,
        withCredentials: true,
        params: httpParams,
      });
    } else {
      return this.httpClient.get(url, {
        headers: headers,
        withCredentials: true,
      });
    }
  }

  getInnerTargetApi(
    url: string,
    params?,
    callback?: (value: any) => void,
    error?: (error: any) => void,
    complete?: () => void
  ): Subscription {
    url = this.makeFullUrlByType(url, "inner");

    let headers = this.getHeaders();

    if (params) {
      let httpParams: HttpParams = this.makeHttpParam(params);

      return this.httpClient
        .get(url, {
          headers: headers,
          withCredentials: true,
          params: httpParams,
        })
        .subscribe(
          (value) => {
            if (callback) callback(value);
          },
          (err) => {
            if (error) error(err);
          },
          () => {
            if (complete) complete();
          }
        );
    } else {
      return this.httpClient
        .get(url, { headers: headers, withCredentials: true })
        .subscribe(
          (value) => {
            if (callback) callback(value);
          },
          (err) => {
            if (error) error(err);
          },
          () => {
            if (complete) complete();
          }
        );
    }
  }

  post(url: string, body?, isDataObjType?, params?): Observable<any> {
    url = this.makeFullUrlByType(url, "base");

    let headers = this.getHeaders();
    let data = null;

    if (body && isDataObjType) {
      data = { data: body };
    } else if (body && !isDataObjType) {
      data = body;
    }

    if (params) {
      let httpParams: HttpParams = this.makeHttpParam(params);
      return this.httpClient.post(url, data, {
        headers: headers,
        withCredentials: true,
        params: httpParams,
      });
    } else {
      return this.httpClient.post(url, data, {
        headers: headers,
        withCredentials: true,
      });
    }
  }

  postInnerTargetApi(
    url: string,
    body?,
    callback?: (value: any) => void,
    error?: (error: any) => void,
    complete?: () => void,
    file?: boolean
  ): Subscription {
    url = this.makeFullUrlByType(url, "inner");

    let headers = this.getHeaders();

    if (body) {
      return this.httpClient
        .post(url, body, { headers: headers, withCredentials: true })
        .subscribe(
          (value) => {
            if (callback) callback(value);
          },
          (err) => {
            if (error) error(err);
          },
          () => {
            if (complete) complete();
          }
        );
    } else {
      return this.httpClient
        .post(url, { headers: headers, withCredentials: true })
        .subscribe(
          (value) => {
            if (callback) callback(value);
          },
          (err) => {
            if (error) error(err);
          },
          () => {
            if (complete) complete();
          }
        );
    }
  }

  patchReqDataType(url: string, body?): Observable<any> {
    url = this.makeFullUrlByType(url, "base");
    let headers = this.getHeaders();

    if (body) {
      return this.httpClient.patch(
        url,
        { data: body },
        { headers: headers, withCredentials: true }
      );
    } else {
      return this.httpClient.patch(url, {
        headers: headers,
        withCredentials: true,
      });
    }
  }

  patchReqDataTypeWithParams(url, body, params): Observable<any> {
    url = this.makeFullUrlByType(url, "base");
    let headers = this.getHeaders();

    let httpParams: HttpParams = this.makeHttpParam(params);
    return this.httpClient.patch(url, body, {
      headers: headers,
      withCredentials: true,
      params: httpParams,
    });
  }

  patchReqBodyType(url: string, body?): Observable<any> {
    url = this.makeFullUrlByType(url, "base");
    let headers = this.getHeaders();

    if (body) {
      return this.httpClient.patch(url, body, {
        headers: headers,
        withCredentials: true,
      });
    } else {
      return this.httpClient.patch(url, null, {
        headers: headers,
        withCredentials: true,
      });
    }
  }

  patchInnerTargetApi(
    url: string,
    body?,
    callback?: (value: any) => void,
    error?: (error: any) => void,
    complete?: () => void
  ): Subscription {
    url = this.makeFullUrlByType(url, "inner");

    let headers = this.getHeaders();

    if (body) {
      return this.httpClient
        .patch(url, body, { headers: headers, withCredentials: true })
        .subscribe(
          (value) => {
            if (callback) callback(value);
          },
          (err) => {
            if (error) error(err);
          },
          () => {
            if (complete) complete();
          }
        );
    } else {
      return this.httpClient
        .patch(url, null, { headers: headers, withCredentials: true })
        .subscribe(
          (value) => {
            if (callback) callback(value);
          },
          (err) => {
            if (error) error(err);
          },
          () => {
            if (complete) complete();
          }
        );
    }
  }

  putInnerTargetApi(
    url: string,
    body?,
    callback?: (value: any) => void,
    error?: (error: any) => void,
    complete?: () => void
  ): Subscription {
    url = this.makeFullUrlByType(url, "inner");

    let headers = this.getHeaders();

    if (body) {
      return this.httpClient
        .put(url, body, { headers: headers, withCredentials: true })
        .subscribe(
          (value) => {
            if (callback) callback(value);
          },
          (err) => {
            if (error) error(err);
          },
          () => {
            if (complete) complete();
          }
        );
    } else {
      return this.httpClient
        .put(url, null, { headers: headers, withCredentials: true })
        .subscribe(
          (value) => {
            if (callback) callback(value);
          },
          (err) => {
            if (error) error(err);
          },
          () => {
            if (complete) complete();
          }
        );
    }
  }

  delReqParamsType(url: string, params?): Observable<any> {
    url = this.makeFullUrlByType(url, "base");
    let headers = this.getHeaders();

    if (params) {
      let httpParams: HttpParams = this.makeHttpParam(params);
      return this.httpClient.delete(url, {
        headers: headers,
        withCredentials: true,
        params: httpParams,
      });
    } else {
      return this.httpClient.delete(url, {
        headers: headers,
        withCredentials: true,
      });
    }
  }

  delReqBodyType(url: string, params?): Observable<any> {
    url = this.makeFullUrlByType(url, "base");
    let headers = this.getHeaders();

    if (params) {
      return this.httpClient.request("DELETE", url, {
        headers: headers,
        body: params,
        withCredentials: true,
      });
    } else {
      return this.httpClient.request("DELETE", url, {
        headers: headers,
        withCredentials: true,
      });
    }
  }

  delInnerTargetApi(
    url: string,
    params?,
    callback?: (value: any) => void,
    error?: (error: any) => void,
    complete?: () => void
  ): Subscription {
    url = this.makeFullUrlByType(url, "inner");

    let headers = this.getHeaders();

    if (params) {
      let httpParams: HttpParams = this.makeHttpParam(params);

      return this.httpClient
        .delete(url, {
          headers: headers,
          withCredentials: true,
          params: httpParams,
        })
        .subscribe(
          (value) => {
            if (callback) callback(value);
          },
          (err) => {
            if (error) error(err);
          },
          () => {
            if (complete) complete();
          }
        );
    } else {
      return this.httpClient
        .delete(url, { headers: headers, withCredentials: true })
        .subscribe(
          (value) => {
            if (callback) callback(value);
          },
          (err) => {
            if (error) error(err);
          },
          () => {
            if (complete) complete();
          }
        );
    }
  }

  private makeFullUrlByType(url, target) {
    if (this.hasDomainFullUrl(url)) {
      return url;
    }
    if (target === "base") {
      return REST_API_REQUEST_CALL_URL.BASE_URL + url;
    } else if (target === "inner") {
      return REST_API_REQUEST_CALL_URL.API_INNER + url;
    } else {
      return REST_API_REQUEST_CALL_URL.SERVICE_URL + url;
    }
  }

  private hasDomainFullUrl(url: String) {
    if (url.indexOf("http") > -1 || url.indexOf("https") > -1) {
      return true;
    }
    return false;
  }

  private makeHttpParam(params) {
    let httpParams = new HttpParams();
    Object.keys(params).forEach(function (key) {
      let param = params[key];
      if (param != undefined) httpParams = httpParams.append(key, param);
    });
    return httpParams;
  }

  getToken(
    callback?: (value: any) => void,
    error?: (error: any) => void,
    complete?: () => void
  ): Subscription {
    sessionStorage.removeItem("_vcd");

    const header = {
      "Access-Control-Allow-Origin": "*",
      "tx-clientid": "tradlinx",
    };

    return this.httpClient
      .request("GET", REST_API_REQUEST_CALL_URL.TOKEN_URL, {
        headers: header,
        withCredentials: true,
        responseType: "text",
      })
      .subscribe(
        (res) => {
          sessionStorage.setItem("_vcd", res);
          this.getSessionInfo((res) => {
            if (res) {
              callback(res);
            } else {
              callback(null);
            }
          });
        },
        (err) => {
          if (callback) callback(null);
        }
      );
  }

  refreshToken(): Observable<any> {
    const header = {
      "Access-Control-Allow-Origin": "*",
      "tx-clientid": "tradlinx",
    };

    return this.httpClient.get(REST_API_REQUEST_CALL_URL.TOKEN_URL, {
      headers: header,
      withCredentials: true,
      responseType: "text",
    });
  }

  redirectAccountLogin() {
    const redirectUrl = encodeURIComponent(window.location.href);
    const targetUrl = `${ACCOUNTS_URL}login?redirectUrl=${redirectUrl}`;
    console.log("targetUrl: ", targetUrl);
    window.location.href = targetUrl;
  }

  private getSessionInfo(
    callback?: (value: any) => void,
    error?: (error: any) => void,
    complete?: () => void
  ): Subscription {
    const access_token = sessionStorage.getItem("_vcd");
    const header = {
      "Access-Control-Allow-Origin": "*",
      "tx-clientid": "tradlinx",
      Authorization: `Bearer ${access_token}`,
    };
    return this.httpClient
      .get(REST_API_REQUEST_CALL_URL.SESSION_DATA_URL, {
        headers: header,
        withCredentials: true,
      })
      .subscribe(
        (res) => {
          const data: any = res;
          const role = data.userTp == "99" ? "consultant" : "guest";
          const profile = {
            displayName: data.email,
            id: data.userId,
            provider: "local",
            username: data.email,
            work: 50,
            role: role,
            corporation: data.corporation,
            // remember: params.rememberMe
          };
          if (data.userTp == "99") {
            localStorage.setItem("currentUser", JSON.stringify(profile));
            callback(res);
          } else {
            this.alertService.error("접속 권한이 없는 사용자입니다.");
            setTimeout(() => {
              callback(null);
            }, 2000);
          }
        },
        (err) => {
          if (callback) callback(null);
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/api.service.ts